'use client'

import { useCallback } from 'react'
import { usePostsStore } from '../ui/components/infinite-posts/posts-store'
import { fetchPosts } from './server'

export function usePostActions() {
  const { posts, appendPosts, loading, pagination, setLoading } =
    usePostsStore()

  const loadMorePosts = useCallback(async () => {
    if (pagination?.isLast || loading) return

    setLoading(true)
    try {
      const { posts: newPosts, pagination: newPagination } = await fetchPosts(
        (pagination?.currentPage || 0) + 1,
        pagination?.limit || 10,
      )

      if (newPosts.length > 0) {
        appendPosts(newPosts, newPagination)
      }
    } catch (error) {
      console.error('Failed to load more posts:', error)
    } finally {
      setLoading(false)
    }
  }, [
    appendPosts,
    loading,
    pagination?.currentPage,
    pagination?.isLast,
    pagination?.limit,
    setLoading,
  ])

  return {
    posts,
    loadMorePosts,
    loading,
  }
}
